/* global axios */
import ApiClient from './ApiClient';

class OpportunitiesAPI extends ApiClient {
  constructor() {
    super('opportunities', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  board(params = {}) {
    return axios.get(`${this.url}/board`, { params });
  }

  dashboard(params = {}) {
    return axios.get(`${this.url}/dashboard`, { params });
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  export(params = {}) {
    return axios.post(`${this.url}/export`, params);
  }

  getById(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}`);
  }

  updateById(opportunityId, payload) {
    return axios.patch(`${this.url}/${opportunityId}`, {
      opportunity: payload,
    });
  }

  updateStatus(opportunityId, status, lossReasonId = null) {
    return axios.patch(`${this.url}/${opportunityId}/status`, {
      status,
      loss_reason_id: lossReasonId,
    });
  }

  moveStage(opportunityId, pipelineStageId) {
    return axios.patch(`${this.url}/${opportunityId}/move_stage`, {
      pipeline_stage_id: pipelineStageId,
    });
  }

  assignOwner(opportunityId, ownerId) {
    return axios.patch(`${this.url}/${opportunityId}/assign_owner`, {
      owner_id: ownerId,
    });
  }

  updateNegotiationFormAnswers(opportunityId, answers) {
    return axios.patch(
      `${this.url}/${opportunityId}/negotiation_form_answers`,
      { negotiation_form_answers: answers }
    );
  }

  updateTemperature(opportunityId, temperature) {
    return axios.patch(`${this.url}/${opportunityId}/temperature`, {
      temperature,
    });
  }

  getNotes(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}/notes`);
  }

  createNote(opportunityId, content) {
    return axios.post(`${this.url}/${opportunityId}/notes`, {
      opportunity_note: {
        content,
        automatic: false,
      },
    });
  }

  getHistories(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}/histories`);
  }

  getActivities(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}/activities`);
  }

  createActivity(opportunityId, payload) {
    return axios.post(`${this.url}/${opportunityId}/activities`, {
      opportunity_activity: payload,
    });
  }

  updateActivityStatus(opportunityId, activityId, status) {
    return axios.patch(
      `${this.url}/${opportunityId}/activities/${activityId}/status`,
      { status }
    );
  }

  rescheduleActivity(opportunityId, activityId, scheduledAt) {
    return axios.patch(
      `${this.url}/${opportunityId}/activities/${activityId}/reschedule`,
      { scheduled_at: scheduledAt }
    );
  }

  getProducts(opportunityId) {
    return axios.get(`${this.url}/${opportunityId}/products`);
  }

  create(payload) {
    return axios.post(this.url, { opportunity: payload });
  }

  createProduct(opportunityId, payload) {
    return axios.post(`${this.url}/${opportunityId}/products`, {
      opportunity_product: payload,
    });
  }

  deleteProduct(opportunityId, productId) {
    return axios.delete(`${this.url}/${opportunityId}/products/${productId}`);
  }
}

export default new OpportunitiesAPI();
